export const DemoTypographyView = () => {
	return (
		<div className="is-page-pad-touch">
			<h2 className="mb-5 text-3xl text-center">Typography</h2>
		</div>
	)
}
